import React from 'react';

import { Control, Controller } from 'react-hook-form';

import { getMessageForRequiredFields } from 'utils/validationUtils';

interface UseFormControlWrapperProps extends React.PropsWithChildren<{}> {
  name: string;
  control?: Control;
  required?: boolean;
  errorMessageReferenceName?: string;
  label?: string;
  validate?: (value: string) => boolean | string;
  trigger?: boolean;
}

const UseFormControlWrapper = ({
  name,
  control,
  required,
  label = '',
  validate,
  errorMessageReferenceName,
  children,
}: UseFormControlWrapperProps) => {
  errorMessageReferenceName = errorMessageReferenceName || label || 'This information';

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? getMessageForRequiredFields(errorMessageReferenceName) : undefined,
          validate: validate ? (value: string) => !value || validate(value) : undefined,
        }}
        render={({ field: { onChange, onBlur } }) => {
          const childrenWithProps = React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, {
                // @ts-ignore
                onChangeControl: onChange,
                onBlurControl: onBlur,
              });
            }

            return child;
          });

          return <>{childrenWithProps}</>;
        }}
      />
    </>
  );
};

export default UseFormControlWrapper;
